import PageAccount from '@/pages/PageAccount'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageAccount
	}

	let page = vuewidget(dom, options)
	return page
}